(function() {

var _ = ui._;
ui.modalClose       = modalClose;
ui.modalIsOpened    = modalIsOpened;
ui.modalOpenContent = modalOpenContent;
ui.modalOpenHE      = modalOpenHE;
ui.modalTitleSet    = modalTitleSet;

var $body;
var $modal;
var $modalContent;
var $modalTitle;
var $modalWindow;
var modalBeforeClose;
ui.loadAdd(onLoad);

function onLoad() {
  $body = _(d.body);
}

function modalCreate() {
  if($modal)
    return;
  $modal = _('div').appendTo($body).attr('class', 'modal').on('click', modalClick).append(
    $modalWindow = _('div').attr('class', 'modal-window').append(
      _('div').attr('class', 'modal-header').append(
        $modalTitle = _('div').attr('class', 'modal-header-title').html('&nbsp;'),
        _('i').attr('class', 'fa fa-times fa-modal-close', 'onclick', 'ui.modalClose()')
      ),
      $modalContent = _('div').attr('class', 'modal-content')
    )
  );

  _(w).on('beforeunload', modalClose);
}

function modalClick(event) {
  if(event.target === event.currentTarget)
    modalClose();
}

function modalClose() {
  if(!modalIsOpened())
    return;
  if(modalBeforeClose)
    modalBeforeClose();
  $modalContent.html('');
  modalTitleSet('&nbsp;');
  modalBeforeClose = null;
  $modal.toggleClass('modal-visible', false);
  $body.toggleClass('body-modal', false);
  w.scrollTo(0, -parseInt($body.el.style.top || '0'));
  $body.css('top', '');
  d.removeEventListener('keydown', onKeyboard);
}

function modalIsOpened() {
  return $modal && $modal.hasClass('modal-visible');
}

function modalOpenContent(content, title, show, fullScreen, beforeClose) {
  modalGet(title, show, fullScreen, beforeClose).html(content).el.scrollTo(0, 0);
}

function modalOpenHE(he, title, show, fullScreen, beforeClose) {
  modalGet(title, show, fullScreen, beforeClose).append(_(he)).el.scrollTo(0, 0);
}

function modalGet(title, show, fullScreen, beforeClose) {
  modalClose();
  if(!$modal)
    modalCreate();
  if(title)
    modalTitleSet(title);
  show = show === undefined ? true : show;
  if(show) {
    $modal.toggleClass('modal-visible', true);
    $modalWindow.toggleClass('modal-window-full-screen', fullScreen === undefined ? false : fullScreen);
    $body.css('top', -w.scrollY + 'px').toggleClass('body-modal', true);
    modalBeforeClose = beforeClose;
  }
  d.addEventListener('keydown', onKeyboard);
  return $modalContent;
}

function modalTitleSet(title) {
  if($modalTitle)
    $modalTitle.html(title);
}

function onKeyboard(event) {
  if(event.which === 27)
    modalClose();
}

})();